"use strict"; // Wordlists
// See: https://github.com/bitcoin/bips/blob/master/bip-0039/bip-0039-wordlists.md

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Wordlist", {
  enumerable: true,
  get: function () {
    return _wordlist.Wordlist;
  }
});
Object.defineProperty(exports, "logger", {
  enumerable: true,
  get: function () {
    return _wordlist.logger;
  }
});
Object.defineProperty(exports, "wordlists", {
  enumerable: true,
  get: function () {
    return _wordlists.wordlists;
  }
});

var _wordlist = require("./wordlist");

var _wordlists = require("./wordlists");